import _objectSpread from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import { createLayerComponent } from '@react-leaflet/core';
import { LayerGroup as LeafletLayerGroup } from 'leaflet';
export var LayerGroup = createLayerComponent(function createLayerGroup(_ref, ctx) {
  var _c = _ref.children,
      options = _objectWithoutProperties(_ref, ["children"]);

  var instance = new LeafletLayerGroup([], options);
  return {
    instance: instance,
    context: _objectSpread(_objectSpread({}, ctx), {}, {
      layerContainer: instance
    })
  };
});